import { tiktokVideos, instagramPosts } from '../../../mocks/socialPosts';

export default function SocialFeed() {
  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-block text-xs font-display font-semibold uppercase tracking-[3px] text-sage-500 mb-2 sm:mb-3">
            Social
          </span>
          <h3 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-gray-900 mb-2 sm:mb-3 tracking-tight">
            Follow My Journey
          </h3>
          <p className="text-xs sm:text-sm text-gray-600 font-sans">@alexrivera.ugc</p>
        </div>

        {/* TikTok Videos */}
        <div className="mb-12 sm:mb-16">
          <div className="flex items-center gap-2.5 sm:gap-3 mb-5 sm:mb-6">
            <div className="w-8 sm:w-9 h-8 sm:h-9 flex items-center justify-center bg-gray-900 rounded-lg sm:rounded-xl">
              <i className="ri-tiktok-line text-white text-base sm:text-lg"></i>
            </div>
            <h4 className="text-lg sm:text-xl font-display font-semibold text-gray-900">
              TikTok
            </h4>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-2 sm:gap-3">
            {tiktokVideos.map((video) => (
              <a
                key={video.id}
                href="#"
                className="group cursor-pointer block"
                rel="nofollow"
              >
                <div className="relative overflow-hidden">
                  <div className="w-full aspect-[9/16]">
                    <img
                      src={video.image}
                      alt={video.caption}
                      title={video.caption}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  {/* Play icon always visible */}
                  <div className="absolute inset-0 bg-black/10 group-hover:bg-black/25 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-9 sm:w-11 h-9 sm:h-11 flex items-center justify-center bg-black/40 backdrop-blur-sm rounded-full group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-play-fill text-white text-lg sm:text-xl"></i>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Instagram Pictures */}
        <div>
          <div className="flex items-center gap-2.5 sm:gap-3 mb-5 sm:mb-6">
            <div className="w-8 sm:w-9 h-8 sm:h-9 flex items-center justify-center bg-gradient-to-br from-sage-400 to-caramel-400 rounded-lg sm:rounded-xl">
              <i className="ri-instagram-line text-white text-base sm:text-lg"></i>
            </div>
            <h4 className="text-lg sm:text-xl font-display font-semibold text-gray-900">
              Instagram
            </h4>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 sm:gap-3">
            {instagramPosts.map((post) => (
              <a
                key={post.id}
                href="#"
                className="group cursor-pointer block"
                rel="nofollow"
              >
                <div className="relative overflow-hidden">
                  <div className="w-full aspect-square">
                    <img
                      src={post.image}
                      alt={post.caption}
                      title={post.caption}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  {/* Subtle hover overlay */}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors duration-300"></div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
